"use strict";
"use client";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _colorPicker = require("@rc-component/color-picker");
var _classnames = _interopRequireDefault(require("classnames"));
var _pickAttrs = _interopRequireDefault(require("rc-util/lib/pickAttrs"));
var _locale = require("../../locale");
var _util = require("../util");
var _ColorClear = _interopRequireDefault(require("./ColorClear"));
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var ColorTrigger = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var color = props.color,
    prefixCls = props.prefixCls,
    open = props.open,
    disabled = props.disabled,
    format = props.format,
    className = props.className,
    showText = props.showText,
    activeIndex = props.activeIndex,
    rest = __rest(props, ["color", "prefixCls", "open", "disabled", "format", "className", "showText", "activeIndex"]);
  var colorTriggerPrefixCls = "".concat(prefixCls, "-trigger");
  var colorTextPrefixCls = "".concat(colorTriggerPrefixCls, "-text");
  var colorTextCellPrefixCls = "".concat(colorTextPrefixCls, "-cell");
  var _ref = (0, _locale.useLocale)('ColorPicker'),
    _ref2 = _slicedToArray(_ref, 1),
    locale = _ref2[0];
  // ============================== Text ==============================
  var desc = _react["default"].useMemo(function () {
    if (!showText) {
      return '';
    }
    if (typeof showText === 'function') {
      return showText(color);
    }
    if (color.cleared) {
      return locale.transparent;
    }
    if (color.isGradient()) {
      return color.getColors().map(function (c, index) {
        var inactive = activeIndex !== -1 && activeIndex !== index;
        return /*#__PURE__*/_react["default"].createElement("span", {
          key: index,
          className: (0, _classnames["default"])(colorTextCellPrefixCls, inactive && "".concat(colorTextCellPrefixCls, "-inactive"))
        }, c.color.toRgbString(), " ", c.percent, "%");
      });
    }
    var hexString = color.toHexString().toUpperCase();
    var alpha = (0, _util.getColorAlpha)(color);
    switch (format) {
      case 'rgb':
        return color.toRgbString();
      case 'hsb':
        return color.toHsbString();
      // case 'hex':
      default:
        return alpha < 100 ? "".concat(hexString.slice(0, 7), ",").concat(alpha, "%") : hexString;
    }
  }, [color, format, showText, activeIndex]);
  // ============================= Render =============================
  var containerNode = (0, _react.useMemo)(function () {
    return color.cleared ? (/*#__PURE__*/_react["default"].createElement(_ColorClear["default"], {
      prefixCls: prefixCls
    })) : (/*#__PURE__*/_react["default"].createElement(_colorPicker.ColorBlock, {
      prefixCls: prefixCls,
      color: color.toCssString()
    }));
  }, [color, prefixCls]);
  return /*#__PURE__*/_react["default"].createElement("div", Object.assign({
    ref: ref,
    className: (0, _classnames["default"])(colorTriggerPrefixCls, className, _defineProperty(_defineProperty({}, "".concat(colorTriggerPrefixCls, "-active"), open), "".concat(colorTriggerPrefixCls, "-disabled"), disabled))
  }, (0, _pickAttrs["default"])(rest)), containerNode, showText && /*#__PURE__*/_react["default"].createElement("div", {
    className: colorTextPrefixCls
  }, desc));
});
var _default = exports["default"] = ColorTrigger;